export default __webpack_public_path__ + "static/media/close.918b1234.svg";